export default __webpack_public_path__ + "static/media/b2b-works-3.b84e21a6.svg";